/*
 * @Author: your name
 * @Date: 2021-04-22 11:38:12
 * @LastEditTime: 2023-11-03 10:30:54
 * @LastEditors: zhangquanming 419654548@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \edc-mobile-web\src\request\url.js
 */
const baseUrl = process.env.VUE_APP_BASE_URL
export { baseUrl }
